<script setup lang="ts">
import { getTranslations } from '@/lib/util/i18n';
import { CoButton } from '@deputy/copilot2';
import PaperPlane from './icons/PaperPlane.vue';

defineProps<{ message: string }>();
defineEmits(['login']);

const t = getTranslations({
  app: '',
  module: 'views',
  file: 'reset-pin-response',
});
</script>

<template>
  <div class="reset-pin-response">
    <PaperPlane class="__illustration" />

    <h1>{{ t('title') }}</h1>

    <p>{{ message }}</p>

    <CoButton
      @click.prevent="$emit('login')"
      class="w-full"
      data-test-id="back-button"
    >
      {{ t('back-button') }}
    </CoButton>
  </div>
</template>

<style scoped>
.reset-pin-response {
  display: block;
  text-align: center;
}

.__illustration {
  margin-bottom: 1.5rem;
}

h1 {
  font-size: 30px;
  font-weight: 500;
}

p {
  margin: 2rem 0;
  font-size: 16px;
}

.reset-pin-response .co-button {
  font-size: 1rem;
  height: 3rem;
}
</style>
